import './index.css';
import Hero from '../../components/Hero';
import Footer from '../../components/Footer';

export default function EquipoPastoral(){
    return(
        <main className="g-main equipo-pastoral">
            <Hero title="Equipo Pastoral" description="Presentación del Equipo Pastoral vigente en nuestras Iglesias" size="s" />
            <section className="content-main">
                Equipo pastoral aquí, con fotografía y descripción de cada integrante
            </section>
            <Footer />
        </main>
    );
}